module.exports = __webpack_public_path__ + "assets/teams-2098cef345ae8f757ec51a7dc3f135e6.svg";